import {
  EXPERIENCES_SHOP_OPTION,
  ExperiencesShopOptionResponse,
  ITrackingProperties,
  ViewedExperienceDetailsProperties,
} from "redmond";
import { put, select } from "redux-saga/effects";
import { actions } from "../actions";
import Logger from "../../../utils/logger";
import { fetchExperienceShopOptions } from "../../../api/v0/shop/fetchExperiencesShopOptions";
import { trackEvent } from "../../../api/v0/analytics/trackEvent";
import { getViewedExperienceDetailsProperties } from "../reducer";

export function* fetchExperiencesShopOptionsSaga(
  action: actions.IFetchExperiencesShopOptions
) {
  const viewedDetailsProperties: ITrackingProperties<ViewedExperienceDetailsProperties> =
    yield select(getViewedExperienceDetailsProperties);
  const { properties, encryptedProperties } = viewedDetailsProperties;

  try {
    const shopOptionsResponse: ExperiencesShopOptionResponse =
      yield fetchExperienceShopOptions(action.request);

    if (shopOptionsResponse.breakdowns.length !== 0) {
      yield put(
        actions.setExperiencesShopOptions(
          shopOptionsResponse.breakdowns.map((breakdown) => ({
            ...breakdown,
            date: action.request.date,
          })),
          shopOptionsResponse.trackingProperties
        )
      );
    } else {
      // there's no available time for requested date, throw an error modal to tell user to select a different date
    }

    trackEvent({
      eventName: EXPERIENCES_SHOP_OPTION,
      properties: {
        ...shopOptionsResponse.trackingProperties,
        ...properties,
        success: true,
      },
      encryptedProperties: [...(encryptedProperties ?? "")],
    });
  } catch (e) {
    trackEvent({
      eventName: EXPERIENCES_SHOP_OPTION,
      properties: {
        ...properties,
        success: false,
      },
      encryptedProperties: [...(encryptedProperties ?? "")],
    });
    yield put(actions.setExperiencesShopOptionsCallStateFailed());
    Logger.debug(e);
  }
}
